var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Gizlilik Sözleşmesi")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHtml && _vm.getHtml.value ? _vm.getHtml.value : '')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }